import React from 'react';

import AccordionTabs from '../../accordion-tabs';

function StoryblokAccordionTabsAdapter({ data, ...rest }) {
  return <AccordionTabs data={data} {...rest} />;
}

export default StoryblokAccordionTabsAdapter;
